<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>ACHETEURS & PARTENAIRES</h2>
          <ul>
            <li><a routerLink="/">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>PARTENAIRES</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


<section class="partners-stats-section">
  <div class="container">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-building"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ totalPartners || 0 }}">0</h3>
          <p class="stat-label">Partenaires Totaux</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-users"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ totalCategories || 0 }}">0</h3>
          <p class="stat-label">Catégories</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-folder"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ totalProjects || 0 }}">0</h3>
          <p class="stat-label">Projets Réalisés</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-chart-line"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ totalYears || 0 }}">0</h3>
          <p class="stat-label">Années de Collaboration</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="partners-search-section">
  <div class="container">
    <div class="search-container">
      <div class="search-header">
        <h3 class="search-title text-white">
          <i class="icofont-search"></i>
          Rechercher un Partenaire
        </h3>
        <p class="search-subtitle">Trouvez rapidement les partenaires qui vous intéressent</p>
      </div>
      
      <div class="search-form-wrapper">
        <div class="search-input-wrapper">
          <i class="icofont-search search-icon"></i>
          <input 
            type="text" 
            class="form-control search-input" 
            [(ngModel)]="search"
            placeholder="Saisir le nom d'un acheteur ou un partenaire..." 
            name="search" 
            autocomplete="off"
          >
          <button class="search-btn" type="button">
            <i class="icofont-search"></i>
          </button>
        </div>
        
        <div class="search-stats">
          <span class="stats-text">
            <i class="icofont-building"></i>
            {{ filteredPartenaires?.length || partenairesType?.length }} catégorie(s) trouvée(s)
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="partners-categories-section">
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">
        <i class="icofont-sitemap"></i>
        Catégories de Partenaires
      </h2>
      <p class="section-subtitle">Explorez nos différents types de partenaires et acheteurs</p>
    </div>
    
    <!-- Loading Skeleton -->
    <div class="loading-skeleton" *ngIf="partenairesType == null">
      <div class="category-skeleton" *ngFor="let item of [].constructor(3)">
        <div class="skeleton-header">
          <p-skeleton height="2rem" width="30%" styleClass="mb-3"></p-skeleton>
          <div class="skeleton-divider"></div>
        </div>
        
        <div class="partners-skeleton" *ngFor="let content of [].constructor(3)">
          <div class="skeleton-partner">
            <div class="skeleton-logo">
              <p-skeleton height="120px" width="120px" styleClass="rounded-3"></p-skeleton>
            </div>
            <div class="skeleton-content">
              <p-skeleton height="1.5rem" width="60%" styleClass="mb-2"></p-skeleton>
              <p-skeleton height="1rem" width="100%" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1rem" width="80%" styleClass="mb-1"></p-skeleton>
              <p-skeleton height="1rem" width="90%"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Partners Categories -->
    <div class="partners-categories" *ngIf="partenairesType">
      <div class="category-section" *ngFor="let partType of filteredPartenaires">
        <div class="category-header">
          <div class="category-icon">
            <i class="icofont-building"></i>
          </div>
          <h3 class="category-title">{{ partType.name }}</h3>
          <div class="category-count">
            <span class="count-badge">{{ partType.partenaires?.length || 0 }} partenaire(s)</span>
          </div>
        </div>
        
        <div class="partners-grid">
          <div class="partner-card" *ngFor="let partenaire of partType.partenaires">
            <div class="partner-logo">
              <img [src]="partenaire.logo" [alt]="partenaire.name">
              <div class="partner-overlay">
                <div class="overlay-content">
                  <button class="contact-btn" (click)="contactPartner(partenaire)">
                    <i class="icofont-envelope"></i>
                    Contacter
                  </button>
                </div>
              </div>
            </div>
            
            <div class="partner-content">
              <h4 class="partner-name">{{ partenaire.name }}</h4>
              <p class="partner-description">
                {{ partenaire.description }}
              </p>
              
              <div class="partner-actions">
                <button class="btn btn-outline-primary" (click)="viewDetails(partenaire)">
                  <i class="icofont-eye"></i>
                  Voir détails
                </button>
                <button class="btn btn-primary" (click)="contactPartner(partenaire)">
                  <i class="icofont-envelope"></i>
                  Contacter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- No Results -->
    <div class="no-results-section" *ngIf="partenairesType && filteredPartenaires?.length === 0">
      <div class="no-results-content text-center">
        <div class="no-results-icon">
          <i class="icofont-search"></i>
        </div>
        <h3 class="no-results-title">Aucun partenaire trouvé</h3>
        <p class="no-results-subtitle">
          Aucun partenaire ne correspond à votre recherche. 
          Essayez de modifier vos critères de recherche.
        </p>
        <div class="no-results-actions">
          <button class="btn btn-primary" (click)="clearSearch()">
            <i class="icofont-refresh"></i>
            Voir tous les partenaires
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="partners-cta-section">
  <div class="container">
    <div class="cta-content text-center">
      <div class="cta-icon">
        <i class="icofont-handshake"></i>
      </div>
      <h2 class="cta-title">Devenez Partenaire</h2>
      <p class="cta-subtitle">
        Rejoignez notre réseau de partenaires et contribuez au développement économique de la Guinée
      </p>
      <div class="cta-actions">
        <a routerLink="/contact" class="btn btn-primary">
          <i class="icofont-envelope"></i>
          Nous Contacter
        </a>
        <a routerLink="/about" class="btn btn-outline-primary">
          <i class="icofont-info-circle"></i>
          En Savoir Plus
        </a>
      </div>
    </div>
  </div>
</section>
